/* Show tactile feedback on the title link before navigating from the sticky buy bar. */
(() => {
  const setup = () => document.querySelectorAll('.sf-buybar .sf-buybar-book').forEach(link => {
    if (link.dataset.sfFeedbackReady) return;
    link.dataset.sfFeedbackReady = 'true';
    link.addEventListener('pointerdown', () => link.classList.add('sf-tap-feedback'), {passive:true});
    link.addEventListener('pointercancel', () => link.classList.remove('sf-tap-feedback'), {passive:true});
    link.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      link.classList.add('sf-tap-feedback');
      // Follow the same native URL/hash as the adjacent buy button.
      // Native anchor navigation also works when already on the product page.
    });
    window.addEventListener('pageshow', () => link.classList.remove('sf-tap-feedback'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
  document.addEventListener('shopify:section:load',setup);
})();
